import { createContext } from "react";

const DialogsContext = createContext({});

export default DialogsContext;
